import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemoveAriaOwnsDirective } from './remove-aria-owns.directive';



@NgModule({
  declarations: [
    RemoveAriaOwnsDirective
  ],
  imports: [
    CommonModule
  ],
  exports:[RemoveAriaOwnsDirective]
})
export class RemoveAriaOwnsModule { }
